import UpdateBlogAPI from "./editBlogAPI";

const UpdateBlogService = async (id: string, data: any): Promise<any> => {
  try {
    return await UpdateBlogAPI(id, data);
  } catch (error) {
    throw error;
  }
};

export default UpdateBlogService;
